// The two bar labels describe the colors of the same Average dataset.
export function reportChartLegend(chart) {
    return [
        { text: 'Above target', color: 'rgba(40, 167, 69, 1)', datasetIndex: 0, pointStyle: 'rect' },
        { text: 'Below target', color: 'rgba(255, 99, 132, 1)', datasetIndex: 0, pointStyle: 'rect' },
        { text: 'Target', color: 'rgb(54, 162, 235)', datasetIndex: 1, pointStyle: 'line' },
    ].map(({ text, color, datasetIndex, pointStyle }) => ({
        text,
        fillStyle: color,
        strokeStyle: color,
        lineWidth: pointStyle === 'line' ? 3 : 0,
        pointStyle,
        datasetIndex,
        hidden: !chart.isDatasetVisible(datasetIndex),
    }));
}
